"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../Link/Link"));

var _AnchorLink = _interopRequireDefault(require("../AnchorLink/AnchorLink"));

var _linkHelper2 = _interopRequireDefault(require("../../helpers/linkHelper"));

var _iconExternalLink = _interopRequireDefault(require("../../icons/icon-external-link.svg"));

var _classNameHelper = require("../../helpers/classNameHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MarkdownLinkRenderer = function MarkdownLinkRenderer(_ref) {
  var _modify;

  var action = _ref.action,
      href = _ref.href,
      children = _ref.children,
      className = _ref.className,
      external = _ref.external;

  var _linkHelper = (0, _linkHelper2["default"])(href, external),
      allowIcon = _linkHelper.allowIcon,
      parsedHref = _linkHelper.href,
      hooks = _linkHelper.hooks,
      openNewTab = _linkHelper.openNewTab,
      scrollTo = _linkHelper.scrollTo;

  var LinkComponent = scrollTo ? _AnchorLink["default"] : _Link["default"];
  var isVisuallyExternal = openNewTab && allowIcon;
  var linkClass = (0, _classNameHelper.modify)((_modify = {}, _defineProperty(_modify, className, className), _defineProperty(_modify, 'custom-react-markdown__link', true), _modify), {
    'with-icon': isVisuallyExternal
  });
  return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    action: action ? function () {
      return action(hooks);
    } : null,
    className: linkClass,
    href: parsedHref,
    external: openNewTab
  }, children, isVisuallyExternal && /*#__PURE__*/_react["default"].createElement(_iconExternalLink["default"], {
    className: "custom-react-markdown__link-icon"
  }));
};

MarkdownLinkRenderer.propTypes = {
  action: _propTypes["default"].func,
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired,
  className: _propTypes["default"].string,
  external: _propTypes["default"].bool
};
MarkdownLinkRenderer.defaultProps = {
  action: null,
  className: '',
  external: false
};
var _default = MarkdownLinkRenderer;
exports["default"] = _default;